export const breakpoints = {
  base: '0em',
  sm: '30em', // 480px
  md: '48em', // 768px
  lg: '64em', // 1024px
  xl: '80em', // 1280px
  '2xl': '90em', // 1440px
  '3xl': '100em', // 1600px
};
